import type { FC, PropsWithChildren } from "react";
import { Portal } from "@mui/material";
import { useAtom } from "jotai";
import { appPortalAtom } from "./AppPortal.atoms";

const AppPortal: FC<PropsWithChildren> = ({ children }) => {
  const [ref] = useAtom(appPortalAtom);
  return <Portal container={() => ref}>{children}</Portal>;
};

export default AppPortal;
